module.exports = __webpack_public_path__ + "static/img/step-073.762934b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-073.png
// module id = wpwz
// module chunks = 1